import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import Modal from "react-modal";
import {CloseSquareOutlined} from "@ant-design/icons";
import {useDispatch} from "react-redux";
import {setPreAuthenticUser, setLoader, setForgotPasswordIsOpen} from "../../reducers/global";
import OtpInput from "react-otp-input";
import {postPreLogin, postVerfiedUser} from "../../api/login";
import {toast} from "react-toastify";
import {Button} from "antd";
import {setLogin} from "../../useAppPullState";
import {theRandomNumber} from "../../app/theRandomNumber";

const ForgotPasswordModal = () => {
    const customStyles = {
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            // marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            backgroundImage: "linear-gradient(to bottom, #003B7E , #0D6EFF)",
            borderRadius: 10,
            width: 320,
            padding: "6px 20px 20px 20px",
        },
    };
    const dispatch = useDispatch();
    const [OTP, setOTP] = useState(null);

    const [verifiredOTP, setVerifiedOTP] = useState(false);
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showOTP, setShowOTP] = useState(false);

    const preAuthUser = useSelector(state => state.global.preAuthUser);
    const forgotPasswordIsOpen = useSelector(state => state.global.forgotPasswordIsOpen);

    const loader = useSelector(state => state.global.loader);

    const sendEmail = async toEmail => {
        if (window.Email)
            await window.Email.send({
                SecureToken: "1a5e1b50-e5f1-4845-ab02-234cff3dc707",
                To: toEmail,
                From: "info@mobietu.com",
                Subject: "Sähköpostin varmennuskoodi SGSpalveluun",
                Body: `Tervehdys, <br/><br/> 
    
            SGS mobiilijäsenkortti vaatii sinulta tunnistautumista.<br/> <br/> 
            
            Syötä oheinen nelinumeroinen koodi kenttään, joka avautui sivulle sähköpostiosoitteesi syöttämisen jälkeen.<br/><br/>  
            
            Tunnus (<strong>${theRandomNumber}</strong>)<br/> <br/> 
            
            Sen jälkeen voit määritellä salasanan, jota käytät aina kirjautuessasi palveluun.<br/> <br/> 
            
            Kiitos ja tervetuloa!<br/> <br/> 
            
            Suomen Golfseniorit<br/><br/> 
            <a>info@golfseniorit.fi</a><br/> 
            <a>www.suomengolfseniorit.fi</a>
             <br/> <br/> <br/> <br/> <br/> <br/><br/> <br/>  `,
            }).then(message => {
                if (message == "OK") {
                    // toast.success(
                    //   "Sähköpostia ei ole verifioitu. Syötäsähköpostiosoitteesi, niin saat sähköpostiisitunnusnumeron, jonka syötät tähän sivulleavautuvaan kenttään"
                    // );
                    setShowOTP(true);
                } else alert("Unable to send email please try again in a moment!");
            });
    };

    function openModal() {
        dispatch(setForgotPasswordIsOpen(true));
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        // subtitle.style.color = "#f00";
    }

    function closeModal() {
        // resetModel();
        dispatch(setForgotPasswordIsOpen(false));
    }

    const stepBag = {
        firstStep:
            "SGS mobiilijäsenkortti vaatii sinulta tunnistautumista. Syötä alla olevaan kenttään sähköpostiosoitteesi, jonka olet rekisteröinyt SGS:lle. Saat sähköpostiisi varmennekoodin. Varaudu, että koodi saattaa mennä myös roskapostiisi. Syötä tämä nelinumeroinen koodi kenttään, joka avautuu tälle sivulle sähköpostiosoitteesi syöttämisen jälkeen. Sen jälkeen voit määritellä salasanan, jolla kirjaudut palveluun.",
        secondStep: "",
    };
    return (
        <Modal
            isOpen={forgotPasswordIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel='forgot Modal'
            ariaHideApp={false}
        >
            <div style={{position: "absolute", top: -3, right: 2, cursor: "pointer"}} onClick={closeModal}>
                <CloseSquareOutlined color='red' style={{color: "white"}}/>
            </div>
            <div className='helpingText' style={{border: "1px solid white", borderRadius: 5, padding: "2px"}}>
                <p style={{color: "white", fontSize: 12, marginBottom: 2}}> {stepBag.firstStep} </p>
            </div>
            {" "}
            <form>
                <div class='mb-3 row'>
                    <label htmlFor='emailForgot' class=' col-form-label' style={{fontSize: 12, color: "white"}}>
                        Sähköposti
                    </label>
                    <div class=''>
                        <input
                            type='email'
                            class='form-control'
                            id='emailForgot'
                            defaultValue={email}
                            maxLength={40}
                            onBlur={e => {
                                // if (e.currentTarget.value != "") {
                                //   if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(e.currentTarget.value)) setEmailError(false);
                                //   else setEmailError(true);
                                // }
                                setEmail(e.currentTarget.value != "" ? e.currentTarget.value.toLowerCase() : "");
                            }}
                            onChange={e => {
                                setEmail(e.currentTarget.value != "" ? e.currentTarget.value.toLowerCase() : "");
                                // setTimeout(e => setEmail(e.currentTarget.value != "" ? e.currentTarget.value.toLowerCase() : ""), 10);
                            }}
                        />
                    </div>
                </div>
                {showOTP && (
                    <div class='mb-3 row'>
                        <label htmlFor='inputPassword' class=' col-form-label' style={{fontSize: 12, color: "white"}}>
                            Kertakäyttökoodi
                        </label>
                        <div class=''>
                            {/* <input
              type='password'
              class='form-control'
              id='inputPassword'
              value={password}
              onChange={e => setPassword(e.currentTarget.value)}
              maxLength={24}
            /> */}
                            <OtpInput
                                value={OTP}
                                type='number'
                                onChange={e => {
                                    setOTP(e);
                                    if (e.length == 4) {
                                        // verifyOTP();
                                        // cons
                                        if (e == theRandomNumber) {
                                            // console.log({ preAuthUser });
                                            let postModel = {
                                                ...preAuthUser,
                                                docName: `${preAuthUser.docName}`,
                                                verifiedEmail: true
                                            };
                                            postVerfiedUser(postModel, res => {
                                                if (res.data.status == 200) {
                                                    setShowOTP(false);
                                                    setShowPassword(true);
                                                    setShowConfirmPassword(true);
                                                }
                                            });
                                        } else {
                                            toast.error("Your OTP code is not correct please check your email.");
                                        }
                                    }
                                }}
                                numInputs={4}
                                renderSeparator={<span>-</span>}
                                renderInput={props => (
                                    <input {...props} type='number'
                                           style={{width: "3.6rem", textAlign: "center", fontWeight: "bold"}}/>
                                )}
                            />
                        </div>
                    </div>
                )}
                {showPassword && (
                    <div class='mb-3 row'>
                        <label htmlFor='inputPassword' class=' col-form-label' style={{fontSize: 12, color: "white"}}>
                            {showConfirmPassword ? "Luo salasana" : "Password"}
                        </label>
                        <div class=''>
                            <input
                                type='password'
                                class='form-control'
                                id='inputPassword'
                                value={password}
                                onChange={e => setPassword(e.currentTarget.value)}
                                maxLength={24}
                            />
                        </div>
                    </div>
                )}
                {showPassword && showConfirmPassword && (
                    <div class='mb-3 row'>
                        <label htmlFor='inputPassword' class=' col-form-label' style={{fontSize: 12, color: "white"}}>
                            Toista salasana
                        </label>
                        <div class=''>
                            <input
                                type='password'
                                class='form-control'
                                id='inputPassword'
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.currentTarget.value)}
                                maxLength={24}
                            />
                        </div>
                    </div>
                )}
                <div className='row' style={{alignItems: "center", justifyContent: "center"}}>
                    <Button
                        loading={loader}
                        onClick={() => {
                            dispatch(setLoader(true));
                            if (!showPassword)
                                postPreLogin({userName: email}, res => {
                                    // console.log({ res });
                                    if (!res.data.Errors) {
                                        // if (showPassword == false) {
                                        dispatch(setPreAuthenticUser(res.data.response.data));
                                        if (res.data.response.data.roleId == 1) {

                                            const paidDateTime = new Date(res.data.response.data.paidDate).getTime();
                                            const currentDateTime = new Date().getTime();
                                            // one year forward from paidDateTime isPaid

                                            const isPaid = paidDateTime + 31556952000 > currentDateTime;
                                            if (res.data.response.data.verifiedEmail && isPaid) {
                                                if (
                                                    res.data.response.data.Email != "" &&
                                                    res.data.response.data.Email != null &&
                                                    res.data.response.data.Email != undefined
                                                )
                                                    sendEmail(res.data.response.data.Email);
                                                if (
                                                    res.data.response.data.Email == "" ||
                                                    res.data.response.data.Email == null ||
                                                    res.data.response.data.Email == undefined
                                                )
                                                    toast.error("Your email is not registered kindly contact support");
                                            } else if (!res.data.response.data.verifiedEmail && isPaid)
                                                toast.error("Your email is not verfied kindly verify it first and create your password");
                                            else if (res.data.response.data.verifiedEmail && isPaid) setShowPassword(true);
                                            else if (!isPaid) {
                                                toast.error(
                                                    "Et ole maksanut jäsenmaksua, vainmaksaneet jäsenet voivat käyttää palvelua.Ota yhteyttä info@golfseniorit.fi"
                                                );
                                            }
                                        }
                                        if (res.data.response.data.roleId == 2) {
                                            setShowPassword(true);
                                        }
                                    }
                                    if (res.data.Errors) {
                                        toast.error("Sähköpostia ei löytynyt SGS-rekisteristä. Ota yhteyttä info@golfseniorit.fi");
                                    }
                                    dispatch(setLoader(false));
                                    // }
                                });
                            if (showPassword && confirmPassword) {
                                if (password == confirmPassword) {
                                    //  dispatch(setLoader(true));
                                    setLogin(true, email, password);
                                    // dispatch(setLoader(false));
                                }
                                if (password != confirmPassword) {
                                    dispatch(setLoader(false));
                                    toast.error("Salasana ei täsmää, tarkista");
                                }
                            }
                        }}
                        // className='btn btn-primary'
                        style={{
                            width: "36%",
                            marginTop: 8,
                            // padding: 6,
                            borderColor: "white",
                            background: "#476da5",
                            color: "white",
                        }}
                        // disabled={false}
                    >
                        Kirjaudu
                    </Button>
                    <div style={{color: "white", fontSize: 12}}>
                        <a href='https://www.mobietu.com/sgsohjeet' target='_blank' style={{color: "white"}}>
                            Instructions
                        </a>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default ForgotPasswordModal;
